
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: 'SignUpReportCancelledModal',
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSignUpReportCancelledModal']),
    closeModal() {
      document.body.classList.remove("is-popup-opened");
      document.body.classList.add("is-popup-closed");
      setTimeout(() => {
        this.toggleSignUpReportCancelledModal();
        document.body.classList.remove("is-popup-closed");
      }, 250);
    },
  },
  computed: {
    ...mapGetters(['showSignUpReportCancelledModal']),
  },
});
